module.exports = __webpack_public_path__ + "img/laptop.b6bf9a06.svg";